import { countdownTarget } from '@content-scheduler/shared/render';
import { Buttons } from '../parts/Buttons';
import { Countdown } from '../parts/Countdown';
import { BarLayout, CardLayout, SplitLayout, layouts } from '../parts/Layouts';
import parts from '../parts/parts.module.css';
import type { TemplateProps } from '../types';

const cx = (...classes: (string | false | undefined)[]) => classes.filter(Boolean).join(' ');

export function Announcement({ doc, ctx, onDismiss }: TemplateProps<'announcement'>) {
    const { eyebrow, headline, body, buttons, image, countdown } = doc.fields;
    const target = countdownTarget(doc, ctx.schedule);
    const slim = doc.variant === 'bar';

    const text = (
        <>
            {eyebrow.trim() && <p className={parts.eyebrow}>{eyebrow}</p>}
            <h2 className={cx(parts.headline, slim && layouts.slimHeadline)}>{headline}</h2>
            {body.trim() && <p className={cx(parts.body, slim && layouts.slimBody)}>{body}</p>}
        </>
    );

    if (slim) {
        return (
            <BarLayout
                text={text}
                actions={
                    <>
                        <Countdown countdown={countdown} target={target} compact />
                        <Buttons buttons={buttons} />
                    </>
                }
                onDismiss={onDismiss}
            />
        );
    }

    const content = (
        <>
            {text}
            <Countdown countdown={countdown} target={target} className={layouts.afterText} />
            <Buttons buttons={buttons} className={layouts.afterText} />
        </>
    );

    return doc.variant === 'split' ? (
        <SplitLayout image={image} onDismiss={onDismiss}>
            {content}
        </SplitLayout>
    ) : (
        <CardLayout image={image} onDismiss={onDismiss}>
            {content}
        </CardLayout>
    );
}
